import React, { useState } from "react";
import { Box } from "@material-ui/core";
import Heatmapchart from "./heatmapchart";
import DbPercentages from "./DbPercentages";
import Linechart from "./linechart";
import DbLeaderboard from "./DbLeaderboard";
import CompletionStatus from "./CompletionStatus";
import constants from "../../../../constants.js";

const BatchDashboard = () => {
  const [learners, setLearners] = useState("");
  const [isLoadingTop, setIsLoadingTop] = useState(true);
  const [isLoadingBottom, setIsLoadingBottom] = useState(true);
  return (
    <div className="adminbatchdashboardmaincontainer">
      <DbPercentages learners={learners} isLoadingTop={isLoadingTop} />
      <div className="batchdashboardStatusContainer">
        {constants.BATCH_TYPE.TESTING!=sessionStorage.getItem("batchType") && <div className="batchattendanceStatusMain">
          <Linechart />
        </div>}
        <div className="batchTestStatusMain">
          {/* <div className="batchTeststatusheader">
    <p className="batchTeststatusText">Completion Status</p>
    <span className="batchTeststatusdropdown"></span>
</div>
<div className="batchTestStatusInnerdiv">
    <p className="batchTestStatusInnerdivText">Completion status will appear once students engage with the platform</p>

</div> */}
          <CompletionStatus />
        </div>
      </div>
      <div className="batchdashboardBottomDiv">
        <DbLeaderboard setLearners={setLearners} isLoadingTop={isLoadingTop} setIsLoadingTop={setIsLoadingTop} isLoadingBottom={isLoadingBottom} setIsLoadingBottom={setIsLoadingBottom} />
        {constants.BATCH_TYPE.TESTING!=sessionStorage.getItem("batchType") && <div className="attendanceRatiooContainer">
          <Heatmapchart />
        </div>}
      </div>
    </div>
  );
};
export default BatchDashboard;
